import { Button, type ButtonProps } from "@gigpro/ui/Button";
import { Check, Copy } from "@gigpro/ui/Icons";
import { cn } from "@gigpro/ui/tailwind/cn";
import React from "react";
import { copyToClipboard } from "utils/copyToClipboard";

interface CopyButtonProps extends ButtonProps {
  copyValue: string | number;
}
export function CopyButton({
  copyValue,
  title = "Click to copy",
  className,
  children = copyValue,
  ...props
}: Readonly<CopyButtonProps>) {
  const [showCheck, setShowCheck] = React.useState(false);
  const timeoutRef = React.useRef<ReturnType<typeof setTimeout> | null>(null);
  const handleClick = () => {
    void copyToClipboard(copyValue.toString()).then((ok) => {
      if (!ok) return;
      setShowCheck(true);
      if (timeoutRef.current) clearTimeout(timeoutRef.current);
      timeoutRef.current = globalThis.setTimeout(() => {
        setShowCheck(false);
        timeoutRef.current = null;
      }, 1500);
    });
  };
  React.useEffect(
    () => () => {
      if (!timeoutRef.current) return;
      clearTimeout(timeoutRef.current);
      timeoutRef.current = null;
    },
    [],
  );
  return (
    <Button
      size="small"
      title={title}
      className={cn("px-0 text-small font-regular", className)}
      {...props}
      onClick={(e) => {
        e.stopPropagation();
        handleClick();
        props.onClick?.(e);
      }}
    >
      {children} {showCheck ? <Check /> : <Copy />}
    </Button>
  );
}
